import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="mt-12 border-t border-white/10 bg-space-950">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-6 text-sm text-slate-400 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <p>Built by Leonid Shamarin — React, TypeScript, Tailwind, GraphQL</p>
        <p>
          Data from{" "}
          <a
            href="https://rickandmortyapi.com/documentation/"
            target="_blank"
            rel="noreferrer"
            className="text-portal-400 underline-offset-2 hover:underline"
          >
            The Rick and Morty API
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
